module.exports = __webpack_public_path__ + "static/Law Of Deeds Instruments & Documents With Allied Matters-eeb098962c49649b4e1774697261a04a.jpg";